import { render } from "./PrestamoCreate.vue?vue&type=template&id=35686318&scoped=true"
import script from "./PrestamoCreate.vue?vue&type=script&lang=js"
export * from "./PrestamoCreate.vue?vue&type=script&lang=js"

import "./PrestamoCreate.vue?vue&type=style&index=0&id=35686318&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35686318"]])

export default __exports__